module.exports = __webpack_public_path__ + "img/shengxian.0063f913.png";